import { Component, Input } from '@angular/core';
import { NgbActiveModal }  from '@ng-bootstrap/ng-bootstrap';

import { StreamSearchService } from '../api/stream-search.service';

@Component({
  selector: 'wor-vendor-change',
  template: `
    <form class="form-horizontal" novalidate #form="ngForm" (ngSubmit)="confirm()">
      <div class="modal-header state clearfix bg-info title">
        <div class="icon pull-left">
          <span><i class="fa fa-truck"></i></span>
        </div>
        <div class="pull-left">
          <h1 translate="VENDOR_INVOICE_SPACE.CHANGE_SUPPLIER"></h1>
        </div>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-sm-12">
            <div class="well text-left">
              {{ vendor?.company_name }}<br>
              <span *ngIf="vendor?.address1">{{ vendor?.address1 }} {{ vendor?.suburb }}, {{ vendor?.state }} {{ vendor?.post_code }}<br></span>
              {{ vendor?.phone | phone }}<br>
              {{ vendor?.email }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <label class="control-label" for="vendor" translate="VENDOR_SPACE.NEW_SUPPLIER"></label>
            <div class="controls autocomplete">
              <wor-typeahead-control
                [(model)]="selected"
                [searchFn]="searchVendors.bind(this)"
                [formatterFn]="formatVendor.bind(this)"
                (onSelect)="chooseVendor($event)"
                [placeholder]="'COMPANY_SPACE.INTEGRATIONS.PLACEHOLDER.SEARCH_PLACEHOLDER' | translate">
              </wor-typeahead-control>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="row">
          <div class="col-sm-4 text-left">
            <button type="button" class="btn btn-cancel"
              (click)="modal.dismiss()"
              translate="GENERAL_SPACE.BUTTON.CANCEL">
            </button>
          </div>
          <div class="col-sm-4 pull-right text-right">
            <button type="submit" class="btn btn-success"
              [disabled]="!selected?.id"
              translate="GENERAL_SPACE.BUTTON.CONFIRM">
            </button>
          </div>
        </div>
      </div>
    </form>
  `
})
export class VendorChangeComponent {
  @Input() vendor: any;

  searchList: any[] = [];
  selected: any = null;

  constructor (
    public  modal               : NgbActiveModal,
    private streamSearchService : StreamSearchService
  ) {}

  formatVendor (vendor: any): string {
    return vendor ? vendor.company_name : '';
  }

  searchVendors (typed: string): Promise<any> {
    return this.streamSearchService.search('vendors', typed)
      .then((vendors: any[]) => this.searchList.concat(vendors));
  }

  chooseVendor (vendor: any): void {
    this.selected = vendor;
  }

  confirm (): void {
    this.modal.close(this.selected);
  }
}
